export default {
  message: {
    fontSize: '18px',
  },
};
